/* eslint-disable @nx/enforce-module-boundaries */
import { Button, HStack, VStack } from '@mybridge/ui';
import { forwardRef, useContext, useEffect } from 'react';
import { SearchFilterFromCompany } from 'v4/components/filters/company-name';
import { SearchFilterDatePosted } from 'v4/components/filters/date-posted';
import { SearchFilterFromMember } from 'v4/components/filters/from-member';
import { SearchFilterPostedBy } from 'v4/components/filters/posted-by';
import { SearchFilterSortBy } from 'v4/components/filters/sort-by';
import { SearchContext } from '../../context';
import _ from 'lodash';
import { css } from '@chakra-ui/react';
import { DeleteIcon } from '@mybridge/icons';
export const SearchPostsFilters = forwardRef(({ ...props }, ref) => {
  const { postsFilters, setPostsFilters, loggedIn, postsSearchListing, refetchPostsSearch, search, resetFilters, setResetFilters } = useContext(SearchContext);


  const { posted_by, date_posted, sort_by, from_member, from_company } =
    postsFilters ?? {};

    // console.log('postsFilters', date_posted)
  const onFilterChange = (filter) => {
    // console.log('filter', filter) 
    const nf = { ...(postsFilters ?? {}), ...(filter ?? {}) };
    setPostsFilters(nf);
    // setResetFilters(true)
    // console.warn(nf);
    // refetchPostsSearch?.({ stale: true });
  };

  const filterCompany = (post) => {
    if(post?.company?.id){
      return post.company
    }
  }

  const fromMemberOptions = _.map(postsSearchListing, 'author');
  const fromCompanyOptions = _.map(postsSearchListing, 'company');

  return (
    <>
      <VStack align='stretch' p={3} gap={3} justifyContent="flex-start">
        {loggedIn && (
          <SearchFilterPostedBy
            defaultValue={posted_by}
            onChange={onFilterChange}
          />
        )}

        <SearchFilterDatePosted
          defaultValue={date_posted}
          onChange={onFilterChange}
        />
        <SearchFilterSortBy defaultValue={sort_by} onChange={onFilterChange} />
        <SearchFilterFromMember
          defaultValue={from_member}
          onChange={onFilterChange}
          defaultArray={fromMemberOptions}
        />
        <SearchFilterFromCompany
          defaultValue={from_company}
          onChange={onFilterChange}
          defaultArray={fromCompanyOptions}
        />
        

        {/* <SearchFilterFromMember
          name="mentioning_member"
          title="Mentioning member"
          defaultValue={from_member}
          onChange={onFilterChange}
        /> */}
        
      </VStack>
      {/* {postsFilters && Object.keys(postsFilters)?.length ? (
          <Button variant="secondary"
          justifyContent="flex-start"
          color="#5B5B5B"
          leftIcon={<DeleteIcon />}
          ms="26px" onClick={() => setPostsFilters()}>
            Clear Filters
          </Button>
        ) : (
          ''
        )} */}
    </>
  );
});
